import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { EventModel } from 'projects/common/igsu-models';
import { SessionService } from '../../data-access/session.service';

/**
 * HeaderComponent is designed to display the header of the application.
 * It adapts its content based on the current route. Additionally, it can display details
 * of an event when such data is provided. This dynamic behavior allows for a responsive
 * and context-aware user experience.
 *
 * To use HeaderComponent, bind the `route` to your current route logic and pass an `EventModel`
 * instance to `selectedEvent` if you need to display event-specific information in the header.
 *
 * Usage:
 * ```html
 * <app-header [route]="currentRoute" [selectedEvent]="eventData"></app-header>
 * ```
 */
@Component({
  selector: 'app-header',
  imports: [CommonModule],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  protected sessionService = inject(SessionService);
  /**
   * The current route of the application, used to determine the header content.
   * Bind this to your routing logic to display the correct header content for each route.
   */
  @Input() route = '';

  /**
   * Event details to be displayed in the header when an event is selected.
   * This input expects an object of type EventModel, which contains the necessary
   * event information.
   */
  @Input() selectedEvent!: EventModel;

  public logo = '';

  ngOnInit(): void {
    const patron = this.sessionService.getPatron();

    this.logo = `../../../../assets/club-images/${patron?.environment}/logo.png`;
  }
}
